export default {
    getUsers: { method: 'get', url: 'access/users' },
    postUsers: { method: 'post', url: 'access/users' },
    updateUsers: { method: 'put', url: 'access/users/{id}' },
    deleteUsers: { method: 'delete', url: 'access/users/{id}' },
}
